// Breakpoints for portrait
export const PORTRAIT_BREAKPOINTS = [0, 380, 420, 460, 580, 640, 840, 1023]
